/**
 *
 * Class 所有类的基类
 * @module Class
 */
'use strict';
define([], function () {
    //
    var lang = {
        extend: function (dest) {
            var i, j, len, src;

            for (j = 1, len = arguments.length; j < len; j++) {
                src = arguments[j];
                for (i in src) {
                    dest[i] = src[i];
                }
            }
            return dest;
        },
        create: Object.create|| (function () {
            function F() {
            }

            return function (proto) {
                F.prototype = proto;
                return new F();
            };
        })()
    };
    (function () {
        // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

        function getPrefixed(name) {
            return window['webkit' + name] || window['moz' + name] || window['ms' + name];
        }

        var lastTime = 0;

        // fallback for IE 7-8
        function timeoutDefer(fn) {
            var time = +new Date(),
                timeToCall = Math.max(0, 16 - (time - lastTime));

            lastTime = time + timeToCall;
            return window.setTimeout(fn, timeToCall);
        }

        function bind(fn, obj) {
            var slice = Array.prototype.slice;

            if (fn.bind) {
                return fn.bind.apply(fn, slice.call(arguments, 1));
            }

            var args = slice.call(arguments, 2);

            return function () {
                return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
            };
        }

        var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
            cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
                getPrefixed('CancelRequestAnimationFrame') || function (id) {
                    window.clearTimeout(id);
                };

        lang.requestAnimFrame = function (fn, context, immediate) {
            if (immediate && requestFn === timeoutDefer) {
                fn.call(context);
            } else {
                return requestFn.call(window, bind(fn, context));
            }
        };
        lang.cancelAnimFrame = function (id) {
            if (id) {
                cancelFn.call(window, id);
            }
        };
    })();
    /**
     * 构造方法
     * @constructor
     * @classdesc 定义继承机制的基类，所有类继承于Class
     * @alias G.base.Class
     * @returns {Class} - 实例化的对象
     */
    var Class = function () {
    };
    /**
     * 设置对象的options属性，如果对象已有options属性，则覆盖合并
     * @method
     * @param {Object} obj - 必填，所要设置的模块
     * @param {Object} options - 必填，需要设置的options
     * @returns {Object} 返回修改后的obj对象
     */
    Class.setOptions = function (obj, options) {
        if (!obj.hasOwnProperty('options')) {
            obj.options = obj.options ? lang.create(obj.options) : {};
        }
        for (var i in options) {
            obj.options[i] = options[i];
        }
        return obj.options;
    }
    /**
     * 继承类,对象属性分为自有属性（attribute）和继承属性（property）;自有属性（attribute）是对象中定义的属性、继承属性（property）是在原型中定义的属性。
     * @method
     * @param {Object} props - 必填；
     * @param {Object} props.options  - 可选，扩展的构造参数
     * @param {Function} props.fun1 - 可选，扩展的原型方法
     * @param {Function} props.fun2 - ……
     * @returns {Class} 返回子类
     */
    Class.extend = function (props) {
        //新对象的构造函数，实现两部分内容
        var NewClass = function () {

            // call the constructor
            //1、调用自定义的构造
            if (this.initialize) {
                this.initialize.apply(this, arguments);
            }

            //2、call all constructor hooks
            //调用构造的钩子函数
            this.callInitHooks();
        };

        //parentProto 父类原型属性
        var parentProto = NewClass.__super__ = this.prototype;
        //proto是NewClass的prototype
        var proto = lang.create(parentProto);//等同Object.Create ，创建一个新的对象，并把 父类原型属性拷贝给新的对象
        //新对象的构造函数
        proto.constructor = NewClass;
        //构成原型链，NewClass中的找不到属性，会向parentProto查找，如此向上查找，最终到Object.prototype
        NewClass.prototype = proto;

        // inherit parent's statics
        //继承父类的静态，其实就是继承父类自有属性（不包括原型属性）
        for (var i in this) {
            if (this.hasOwnProperty(i) && i !== 'prototype') {
                NewClass[i] = this[i];
            }
        }

        // mix static properties into the class
        //传参的属性（props）的statics给NewClass.prototype，干掉传参的属性（props）的statics
        if (props.statics) {
            lang.extend(NewClass, props.statics);
            delete props.statics;
        }

        // mix includes into the prototype
        //通过includes实现多继承这里继承一个可枚举的对象
        //proto=== NewClass.prototype
        //NewClass.prototype把includes的包含起来。
        if (props.includes) {
            lang.extend.apply(null, [proto].concat(props.includes));
            delete props.includes;
        }

        // merge options
        //proto.options=== NewClass.prototype.options
        if (proto.options) {
            props.options = lang.extend(lang.create(proto.options), props.options);
        }

        // mix given properties into the prototype
        //把(props)拷贝给 NewClass.prototype
        lang.extend(proto, props);

        proto._initHooks = [];

        //钩子函数
        // add method for calling all hooks
        proto.callInitHooks = function () {

            if (this._initHooksCalled) {
                return;
            }

            if (parentProto.callInitHooks) {
                parentProto.callInitHooks.call(this);
            }

            this._initHooksCalled = true;

            for (var i = 0, len = proto._initHooks.length; i < len; i++) {
                proto._initHooks[i].call(this);
            }
        };

        return NewClass;
    };

    /**
     * 扩展类
     * @method
     * @param {Object} props - 必填
     * @param {Function} props.fun1 - 可选，扩展的原型方法
     * @param {Function} props.fun2 - ……
     * @returns {Class} this - 当前对象
     */
    Class.include = function (props) {
        ;
        props = 'prototype' in props ? props.prototype : props;
        lang.extend(this.prototype, props);
        return this;
    };

    /**
     * 将options参数与类的options的属性覆盖合并
     * @method
     * @param {Object} options - 必填，构造参数options
     * @returns {Class} this - 当前对象
     */
    Class.mergeOptions = function (options) {
        lang.extend(this.prototype.options, options);
        return this;
    };



    Class.addInitHook = function (fn) { // (Function) || (String, args...)
        var args = Array.prototype.slice.call(arguments, 1);

        var init = typeof fn === 'function' ? fn : function () {
            this[fn].apply(this, args);
        };

        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };


    /**
     * 只继承原型链上的方法，不构成父子关系
     * @method
     * @private
     * @param target
     * @param source
     * @param overlay
     * @returns {*}
     */
    Class.defaults = function (target, source, overlay) {
        for (var key in source) {
            if (source.hasOwnProperty(key)
                && (overlay ? source[key] != null : target[key] == null)
            ) {
                target[key] = source[key];
            }
        }
        return target;
    }

    /**
     * 原型链继承
     *     function F() {
            }

     return function (proto) {
                F.prototype = proto;
                return new F();
            };
     *@method
     * @private
     * @param clazz
     * @param baseClazz
     */
    Class.inherits = function (clazz, baseClazz) {
        var clazzPrototype = clazz.prototype;

        function F() {
        }

        F.prototype = baseClazz.prototype;
        clazz.prototype = new F();

        for (var prop in clazzPrototype) {
            clazz.prototype[prop] = clazzPrototype[prop];
        }
        clazz.prototype.constructor = clazz;
        clazz.superClass = baseClazz;
    }

    /**
     * 只继承原型上的方法，没有继承关系，不构成父子关系
     * @method
     * @private
     * @param {Object|Function} target
     * @param {Object|Function} sorce
     * @param {boolean} overlay
     */
    Class.mixin = function (target, source, overlay) {
        target = 'prototype' in target ? target.prototype : target;
        source = 'prototype' in source ? source.prototype : source;

        Class.defaults(target, source, overlay);
    }


    Class.prototype = {
        /**
         * 判断a和b值是否相等；如果a、b都是对象，则只有所有属性都相同才相等;
         * @method
         * @param a {Object} 必填，用于比较的对象
         * @param b {Object} 必填，用于比较的对象
         * @returns {boolean} 相等返回ture，否则返回false；
         */
        equals: function (a, b) {
            var f = false;
            f = eqs(a, b) && eqs(b, a);
            return f;
            //
            function eqs(a, b) {
                if (a && a.constructor == Object) {
                    if (b && b.constructor == Object) {
                        for (var k in a) {
                            var val1 = a[k],
                                val2 = b[k];
                            var flag = eqs(val1, val2) && eqs(val2, val1);
                            if (!flag) {
                                return false;
                            }
                        }
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return a === b;
                }
            }
        }
    }
    return Class;
});